import { dialog, InputJson, toDisplayCase } from "../../../../../nq-component";
import {
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import BaseFormPage from "../../../../../base/BaseFormPage";
import NavBar from "../../../../../components/navbar";
import DialogModal from "../../../../../components/Dialog";
import InventoryFormPresenter from "./InventoryFormPresenter";
import InventoryTable, { QuantityBulkInput } from "./components/InventoryTable";
import SaveProgressBar from "../../../../../components/SaveProgressBar";
import ActionButtons from "./components/ActionButtons";

class InventoryFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      raw: null,
      advanced: false,
      selectedRawIds: [],
      infiniteItems: [],
      skip: 0,
      hasMore: true,
      isLoading: false,
      selectedQuantities: {},
      inputQuantity: "",
      searchKeyword: "",
      categories: [],
      selectedCategory: null,
      actualCountDate: this.getCurrentDateTime(),
      saveProgress: {
        visible: false,
        current: 0,
        total: 0,
        percent: 0,
        label: "",
      },
    };

    this.presenter = new InventoryFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
    );
  }

  getCollectionName() {
    return "inventory";
  }

  async componentDidMount() {
    super.componentDidMount();
  }

  getCurrentDateTime() {
    return new Date().toISOString();
  }

  async fetchInfiniteItems(isInitial = false) {
    this.presenter.fetchInfiniteItems((isInitial = false));
  }

  handleInfiniteScroll = (e) => {
    this.presenter.handleInfiniteScroll(e);
  };

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  validateQuantities() {
    const { infiniteItems, selectedQuantities } = this.state;
    const missing = infiniteItems.filter((item) => {
      const qty = selectedQuantities[item.id]?.quantity;
      return qty === undefined || qty === null || qty === "";
    });
    return missing;
  }

  onSubmitForm(e) {
    e.preventDefault();

    // const missing = this.validateQuantities();
    // if (missing.length > 0) {
    //   dialog.fire({
    //     html: (
    //       <DialogModal
    //         icon="bi bi-exclamation-triangle-fill"
    //         iconColor="#e74c3c"
    //         title="Incomplete Quantities"
    //         message={`Please fill in the quantity for all items before proceeding. ${missing.length} item(s) are missing a quantity.`}
    //         isCancelButton={false}
    //         onSubmit={() => dialog.close()}
    //         onClose={() => dialog.close()}
    //       />
    //     ),
    //     footer: false,
    //   });
    //   return;
    // }

    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.submit(false)}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onSubmitActualForm(e) {
    e.preventDefault();

    const missing = this.validateQuantities();
    if (missing.length > 0) {
      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-exclamation-triangle-fill"
            iconColor="#e74c3c"
            title="Incomplete Quantities"
            message={`Please fill in the quantity for all items before proceeding. ${missing.length} item(s) are missing a quantity.`}
            isCancelButton={false}
            onSubmit={() => dialog.close()}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
      return;
    }

    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.submit(true)}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onChange(value, field) {
    if (field === "quantity") {
      const hasValue = value !== undefined && value !== null && value !== "";
      this.setState({ hasQuantity: hasValue });
    }

    this.presenter.onChange(value, field);
  }

  handleSelectAll = (e) => {
    const checked = e.target.checked;
    const allIds = this.state.infiniteItems.map((item) => item.id);

    this.setState({
      selectedRawIds: checked ? allIds : [],
    });
  };

  handleSelectOne = (e, id) => {
    const { selectedRawIds } = this.state;
    const updated = e.target.checked
      ? [...selectedRawIds, id]
      : selectedRawIds.filter((itemId) => itemId !== id);

    this.setState({ selectedRawIds: updated });
  };

  applyBulkQuantityUpdate = () => {
    const quantity = this.state.inputQuantity.trim();
    if (!quantity) return;

    const { selectedRawIds, infiniteItems, selectedQuantities, object } =
      this.state;

    const updatedQuantities = { ...selectedQuantities };
    const updatedRawMap = new Map(
      (object.raw_materials || []).map((item) => [item.id, item]),
    );

    selectedRawIds.forEach((id) => {
      const item = infiniteItems.find((itm) => itm.id === id);
      if (item) {
        const updatedItem = { ...item, quantity };

        updatedQuantities[id] = updatedItem;
        updatedRawMap.set(id, updatedItem);
      }
    });

    this.setState({
      selectedQuantities: updatedQuantities,
      object: {
        ...object,
        raw_materials: Array.from(updatedRawMap.values()),
      },
      inputQuantity: "",
      selectedRawIds: [],
    });
  };

  handleSearchChange = async (keyword) => {
    this.setState({ searchKeyword: keyword });
    await this.presenter.fetchInfiniteItems(true, keyword);
  };

  getAdjustmentType() {
    const search = this.props.location?.search || "";
    const params = new URLSearchParams(search);
    return params.get("type");
  }

  searchSubmit(where, merge) {
    this.presenter.searchSubmit(where, merge);
  }

  async onCategoryChange(selectedOption) {
    this.setState({ selectedCategory: selectedOption });

    if (selectedOption) {
      // Filter by category

      await this.presenter.fetchInfiniteItems(true, null, selectedOption.value); // Pass category ID
    } else {
      // Clear category filter
      await this.presenter.fetchInfiniteItems(true, null, null);
    }
  }

  showSaveProgress(total, label = "Saving inventory...") {
    this.setState({
      saveProgress: {
        visible: true,
        current: 0,
        total,
        percent: 0,
        label,
      },
    });
  }

  updateSaveProgress(current, label) {
    const total = this.state.saveProgress.total || 0;
    const percent = total ? Math.round((current / total) * 100) : 0;

    this.setState({
      saveProgress: {
        ...this.state.saveProgress,
        current,
        percent,
        label: label ?? this.state.saveProgress.label,
      },
    });
  }

  hideSaveProgress() {
    this.setState({
      saveProgress: {
        visible: false,
        current: 0,
        total: 0,
        percent: 0,
        label: "",
      },
    });
  }

  render() {
    const { object, categories, selectedCategory, actualCountDate } =
      this.state;
    const adjustmentType = this.getAdjustmentType();
    const user = this.getCurrentUser();
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Edit ";
    return (
      <>
        <NavBar />
        <SaveProgressBar progress={this.state.saveProgress} />

        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h2
                className="fw-bold mt-3 text-capitalize"
                style={{ color: "#82c14a" }}
              >
                <i
                  onClick={() => this.navigateBack()}
                  class="bi bi-chevron-compact-left"
                  style={{ color: "black" }}
                ></i>
                {label +
                  (schema.label ||
                    toDisplayCase(this.getCollectionName()))}{" "}
                : <span className="text-dark">{adjustmentType}</span>
              </h2>
              <div
                className="mt-2 shadow rounded p-3 px-lg-5 py-lg-4"
                style={{ backgroundColor: "#f6f5fa" }}
              >
                <h6>Details</h6>
                <hr />
                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChange.bind(this)}
                        rows="15"
                      />
                    ) : adjustmentType !== "Actual Counts" ? (
                      <QuantityBulkInput
                        quantity={this.state.inputQuantity}
                        isDisabled={this.state.selectedRawIds.length === 0}
                        onChange={(e) =>
                          this.setState({ inputQuantity: e.target.value })
                        }
                        onUpdate={this.applyBulkQuantityUpdate}
                      />
                    ) : (
                      <div className="mb-2"></div>
                    )}
                  </div>

                  <InventoryTable
                    title="Raw Materials Breakdown"
                    items={this.state.infiniteItems}
                    selectedIds={this.state.selectedRawIds}
                    selectedQuantities={this.state.selectedQuantities}
                    isLoading={this.state.isLoading}
                    searchKeyword={this.state.searchKeyword}
                    onSearchChange={this.handleSearchChange}
                    onSelectAll={this.handleSelectAll}
                    onSelectOne={this.handleSelectOne}
                    onQuantityChange={(e, item) => {
                      const qty = e.target.value;
                      this.setState((prev) => ({
                        selectedQuantities: {
                          ...prev.selectedQuantities,
                          [item.id]: {
                            ...item,
                            quantity: qty,
                          },
                        },
                      }));
                    }}
                    onScroll={this.handleInfiniteScroll}
                    showCheck={
                      adjustmentType !== "Actual Counts" ? true : false
                    }
                    onChange={this.onCategoryChange.bind(this)}
                    categories={categories}
                    selectedCategory={selectedCategory}
                  />

                  <ActionButtons
                    onCancel={this.onClickBack.bind(this)}
                    onSubmit={this.onSubmitForm.bind(this)}
                    onPartiallySave={this.onSubmitActualForm.bind(this)}
                    showSubmit={
                      !user?.roles?.some((role) => role.id === "Staff")
                    }
                    showPartiallySave={adjustmentType === "Actual Count"}
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(InventoryFormPage);
